import axios from 'axios';

export function getBFFApiClient() {
    if (import.meta.env.VITE_PUBLIC_BFF_URL === undefined) {
        throw new Error('BFF_URL is undefined');
    }

    return axios.create({
        baseURL: import.meta.env.VITE_PUBLIC_BFF_URL,
        withCredentials: true,

        validateStatus: () => true,
    });
}

export function getBFFUrl(path: string) {
    if (import.meta.env.VITE_PUBLIC_BFF_URL === undefined) {
        throw new Error('BFF_URL is undefined');
    }

    return `${import.meta.env.VITE_PUBLIC_BFF_URL}${path}`;
}
